import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
// Helper
import {Helper} from '../helpers/helper';
// Socket
import {Socket} from 'ng-socket-io';
// Modales
import {EmpleadosServicio} from './empleado.service';
import {ActivatedRoute, Params} from '@angular/router';

@Injectable()
export class RutasService {
  // tslint:disable-next-line:max-line-length
  constructor(private _http: HttpClient, private helper: Helper, private socket: Socket, private empleadoService: EmpleadosServicio, private route: ActivatedRoute) {
  }

  cargarTodasLasRutas(omitir = false, limit?, offset?, busqueda?, estado = '1') {
    let params = new HttpParams();
    if (limit && !isNaN(limit)) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (busqueda) {
      params = params.append('busqueda', busqueda);
    }
    if (estado) {
      params = params.append('estado', estado);
    }

    if (this.empleadoService.datosEmpleado.tipo_empleado === 3 || omitir) {

      return this._http.get<{ rutas: any[], total_items: number }>(`${this.helper.urlServer}/api/v1/listado-rutas`,
        {headers: this.helper.getHeader(localStorage.getItem('token')), params});
    } else {
      return this.cargarRutasAsignadas(this.empleadoService.datosEmpleado.ID_EMPLEADO);
    }

  }

  cargarTodasLasRutasConPlazo(omitir = false, limit?, offset?, busqueda?, estado = '1') {
    let params = new HttpParams();
    if (limit && !isNaN(limit)) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (busqueda) {
      params = params.append('busqueda', busqueda);
    }
    if (estado) {
      params = params.append('estado', estado);
    }

    if (this.empleadoService.datosEmpleado.tipo_empleado === 3 || omitir) {

      return this._http.get<{
        plazo_general: any;
        rutas: any[], total_items: number }>(`${this.helper.urlServer}/api/v1/listado-rutas-plazo`,
        {headers: this.helper.getHeader(localStorage.getItem('token')), params});
    } else {
      return this.cargarRutasAsignadas(this.empleadoService.datosEmpleado.ID_EMPLEADO);
    }

  }

  cargarRutasAsignadas(ID_EMPLEADO, limit?, offset?, busqueda?, estado?) {
    let params = new HttpParams();
    if (limit && !isNaN(limit)) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (busqueda) {
      params = params.append('busqueda', busqueda);
    }
    if (estado) {
      params = params.append('estado', estado);
    }

    return this._http.get<{ rutas: any[], total_items: number }>(`${this.helper.urlServer}/api/v1/listado-rutas-asignadas/${ID_EMPLEADO}`,
      {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  crearRuta(data: any) {
    return this._http.post(`${this.helper.urlServer}/api/v1/registrar-ruta`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  asignarRutaEmpleado(ruta, ID_EMPLEADO, asignado_por) {
    return this._http.put(`${this.helper.urlServer}/api/v1/asignar-ruta-empleado`,
      {ruta, ID_EMPLEADO, asignado_por},
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  editarRuta(data) {
    return this._http.put(`${this.helper.urlServer}/api/v1/editar-ruta`, {data},
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  desactivarRuta(data) {
    return this._http.put(`${this.helper.urlServer}/api/v1/desactivar-ruta`, {data},
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  detalleRuta(ID_RUTA) {
    return this._http.get(`${this.helper.urlServer}/api/v1/detalle-ruta/${ID_RUTA}`,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  // Mostrar todas las rutas de un empleado
  cargarTodasLasRutasDelEmpleado(ID_EMPLEADO: number) {
    return this._http.get(
      `${this.helper.urlServer}/api/v1/cargar-todas-rutas-empleado/${ID_EMPLEADO}`,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  asignarRutasEmpleado(ID_RUTA, ID_EMPLEADO, asignado_por, descripcion) {
    return this._http.put(`${this.helper.urlServer}/api/v1/asignar-rutas-empleado`,
      {ID_RUTA, ID_EMPLEADO, asignado_por, descripcion},
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  restablecerConfiguracionRuta(ID_RUTA) {
    return this._http.put(`${this.helper.urlServer}/api/v1/restablecer-configuracion-ruta`,
      {ID_RUTA},
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  getSelectedRoutes() {
    let rutasSeleccionadas = [];
    if (localStorage.getItem('rutasSeleccionadas')) {
      rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }
    return rutasSeleccionadas;
  }

  setSelectedRoutes(routes) {

      localStorage.setItem('rutasSeleccionadas', JSON.stringify(routes));

  }

  removeSelectedRoutes() {
    if (localStorage.getItem('rutasSeleccionadas')) {
      localStorage.removeItem('rutasSeleccionadas');
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/rutas.service.ts